import React from "react";
import { GitCompare, Check } from "lucide-react";

interface Props {
  enabled:  boolean;
  onToggle: () => void;
}

const CompareBtn: React.FC<Props> = ({ enabled, onToggle }) => (
  <button
    onClick={onToggle}
    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold
      border cursor-pointer transition-all duration-150 whitespace-nowrap
      ${enabled
        ? "bg-violet-600 text-white border-violet-500 shadow-sm shadow-violet-200"
        : "bg-white text-slate-500 border-slate-200 hover:border-violet-400 hover:text-violet-600 hover:bg-violet-50"
      }`}
  >
    <GitCompare size={13} strokeWidth={2} />
    Comparer
    {enabled && <Check size={11} strokeWidth={2.5} className="ml-0.5" />}
  </button>
);

export default CompareBtn;